module.exports = __webpack_public_path__ + "img/jyzr.75824b61.jpg";